import React, { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import EditComponentTranslationQueryRenderer from "@/Components/EditComponentTranslation/QueryRenderer/EditComponentTranslationQueryRenderer";


interface EditComponentTranslationMainView {
    isOpen: boolean;
    setIsOpen: any;
    node: any;
    lang: string;
}

const EditComponentTranslationMainView: FunctionComponent<EditComponentTranslationMainView> = ({
    isOpen,
    setIsOpen,
    node,
    lang,
}) => {
    const { t } = useTranslation();

    const [edges, setEdges] = useState({
        lang: lang,
        component: node
    });

    return <EditComponentTranslationQueryRenderer edges={edges} setEdges={setEdges} isOpen={isOpen} setIsOpen={setIsOpen} node={node}  lang={lang}  />;
};

export default EditComponentTranslationMainView;
